import "./HeroImg.css";
import React from "react";
import IntroImg from "../assets/fondo.jpg";
import { Link } from 'react-router-dom'; 

const HeroImg = () => {
  return (
    <div className="hero">
      <div className="mask">
        <img className="into-img" src={IntroImg} alt="IntroImg" />
      </div>

      <div className="content">
        <p>
          Bienvenido a esta Empresa Colombiana de
          Energía solar, pensada para hogares, empresas y el planeta.
        </p>
        <h1>
          E ING Soluciones S.A.S. 
        </h1>
        <div>
          <Link to="/project" className="btn">Projects</Link>
          <Link to="/contact" className="btn btn-light">Contact</Link>
        </div>
      </div>
    </div>
  );
};

export default HeroImg;
